import axios from "axios";
import EncryptUtility from '../components/utility/js/encrypt-utility'

const authHeader = () => {
  let au_header = EncryptUtility.localStorageDecrypt('Token');
  if (au_header) {     
    axios.defaults.headers = {
      Authorization: "Bearer " + au_header,
    };
  } else {    
    delete axios.defaults.headers.Authorization;
  }
};

export default authHeader